<template>
  <div v-bem="{rtl: $i18n.locale === 'ar', sent: submitStatus === 'SENT'}">
    <h3 v-bem:title v-if="submitStatus !== 'SENT' && !thankyou">{{$t('form.account.title')}} <small>{{$t('form.account.text')}}</small></h3>
    <div v-bem:confirm v-if="submitStatus === 'SENT' || thankyou">
      <div class="intro"><img src="@/assets/img/icons/confirm.svg" alt=""></div>
      <div class="content" v-if="userAlreadyExists">
        <h2>{{$t('form.userExists.hello')}} {{user.firstname}}</h2>
        <p>{{$t('form.userExists.emailExists')}} {{user.email}} {{$t('form.userExists.login')}}</p>
        <br>
        <a href="https://succursalesrenault.ma/onlinestore/admin/public/client">{{$t('header.login')}}</a>
      </div>
      <div class="content" v-else>
        <h2>{{$t('form.account.congratulations')}} {{user.firstname}} <small>{{$t('form.account.personnel-space')}}</small></h2>
        <!-- <p>{{$t('form.account.check-email')}} <strong>{{user.email}}</strong> {{$t('form.account.activate')}}</p> -->
        <p>{{$t('form.account.activate')}}</p>
        <br>
        <p v-if="user.trade_in && !trade">{{$t('form.account.reprise-confirm')}}</p>
        <!-- <p class="gris">{{$t('form.account.spam')}}</p> -->
        <!-- <a href="javascript:;" @click="resendEmail" v-if="!reSent">{{$t('form.account.re-send')}}</a> -->
        <!-- <p v-else class="text-green">&check; {{$t('form.account.re-sent')}}</p> -->
      </div>
    </div>
    <p v-bem:error v-if="submitStatus === 'SUBMIT_ERROR' && !thankyou">{{$t('form.error.register')}}</p>
    <Loader v-if="submitStatus === 'PENDING' && !thankyou" />
		<form @submit.prevent="submit" class="row form" v-if="submitStatus !== 'SENT' && submitStatus !== 'PENDING' && !thankyou">
			<div class="col-12">
				<div :class="['form-control radio', {error: $v.user.gender.$dirty && $v.user.gender.$invalid}]">
					<strong>{{$t('form.account.gender')}} </strong>
					<label>{{$t('form.account.mrs')}}
						<input v-model="$v.user.gender.$model" type="radio" name="gender" value="madame">
						<span></span>
					</label>
					<label>{{$t('form.account.mr')}}
						<input v-model="$v.user.gender.$model" type="radio" name="gender" value="monsieur">
						<span></span>
					</label>
					<div class="errors" v-if="$v.user.gender.$dirty">
						<p v-if="!$v.user.gender.required">{{$t('form.error.required.gender')}}</p>
					</div>
				</div>
			</div>
      <div class="row">
        <div class="col-6 col-m-6">
          <div class="form-control">
            <input
            v-model="$v.user.lastname.$model"
            type="text"
            name="lastname"
            :class="{error: $v.user.lastname.$dirty && $v.user.lastname.$invalid}"
            :placeholder="`${$t('form.lastname')} *`"
            >
            <div class="errors" v-if="$v.user.lastname.$dirty">
              <p v-if="!$v.user.lastname.required">{{$t('form.error.required.lastname')}}</p>
              <p v-if="!$v.user.lastname.custom_alpha">{{$t('form.error.lettres.lastname')}}</p>
              <p v-if="!$v.user.lastname.minLength">{{$t('form.error.min.lastname')}}</p>
              <p v-if="!$v.user.lastname.maxLength">{{$t('form.error.max.lastname')}}</p>
            </div>
          </div>
        </div>
        <div class="col-6 col-m-6">
          <div class="form-control">
            <input
            v-model="$v.user.firstname.$model"
            type="text"
            name="firstname"
            :class="{error: $v.user.firstname.$dirty && $v.user.firstname.$invalid}"
            :placeholder="`${$t('form.firstname')} *`"
            >
            <div class="errors" v-if="$v.user.firstname.$dirty">
              <p v-if="!$v.user.firstname.required">{{$t('form.error.required.firstname')}}</p>
              <p v-if="!$v.user.firstname.custom_alpha">{{$t('form.error.lettres.firstname')}}</p>
              <p v-if="!$v.user.firstname.minLength">{{$t('form.error.min.firstname')}}</p>
              <p v-if="!$v.user.firstname.maxLength">{{$t('form.error.max.firstname')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-m-6">
				<div class="form-control">
					<input
					v-model="$v.user.city.$model"
					type="text"
					name="city"
					:class="{error: $v.user.city.$dirty && $v.user.city.$invalid}"
					:placeholder="`${$t('form.city')} *`"
					>
					<div class="errors" v-if="$v.user.city.$dirty">
						<p v-if="!$v.user.city.required">{{$t('form.error.required.city')}}</p>
            <p v-if="!$v.user.city.custom_alpha">{{$t('form.error.lettres.city')}}</p>
            <p v-if="!$v.user.city.minLength">{{$t('form.error.min.city')}}</p>
            <p v-if="!$v.user.city.maxLength">{{$t('form.error.max.city')}}</p>
					</div>
				</div>
			</div>
			<div class="col-6 col-m-6">
				<div class="form-control">
					<input
					v-model="$v.user.phone.$model"
					type="tel"
					name="phone"
					:class="{error: $v.user.phone.$dirty && $v.user.phone.$invalid}"
					:placeholder="`${$t('form.phone')} *`"
					>
					<div class="errors" v-if="$v.user.phone.$dirty">
						<p v-if="!$v.user.phone.required">{{$t('form.error.required.phone')}}</p>
						<p v-if="!$v.user.phone.custom_phone">{{$t('form.error.valid.phone')}}</p>
					</div>
				</div>
			</div>
      <div class="col-12">
				<div class="form-control">
					<input
					v-model="$v.user.email.$model"
					type="email"
					name="email"
					:class="{error: $v.user.email.$dirty && $v.user.email.$invalid}"
					:placeholder="`${$t('form.email')} *`"
					>
					<div class="errors" v-if="$v.user.email.$dirty">
						<p v-if="!$v.user.email.required">{{$t('form.error.required.email')}}</p>
						<p v-if="!$v.user.email.custom_email">{{$t('form.error.valid.email')}}</p>
					</div>
				</div>
			</div>
      <!-- <div class="col-12">
				<div class="form-control">
					<input
					v-model="$v.user.password.$model"
					type="password"
					name="password"
					:class="{error: $v.user.password.$dirty && $v.user.password.$invalid}"
					placeholder="Mot de passe *"
					>
					<div class="errors" v-if="$v.user.password.$dirty">
						<p v-if="!$v.user.password.required">Veuillez renseigner votre mot de passe</p>
            <p v-if="!$v.user.password.minLength">Le mot de passe doit avoir au moins {{$v.user.city.$params.minLength.min}} lettres</p>
					</div>
				</div>
			</div> -->
			<!-- <div class="col-12">
				<div :class="['custom-checkbox', {'animate': !$v.user.test_drive.$model}]">
          <input v-model="$v.user.test_drive.$model" type="checkbox" name="test_drive" @change="$v.user.test_drive.$touch()">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="69.806" height="34.684" viewBox="0 0 69.806 34.684"><path d="M10.74,41.916c0-5.326.326-6.087,5.654-12.394C21.831,23,24.44,21.476,30.2,21.476H44.012c6.089,0,9.46,1.089,14.461,4.46l8.264,6.2,5.328,1.3c5.763,1.307,8.481,4.675,8.481,10.223a11.852,11.852,0,0,1-2.175,7.066L75.327,48.55a7.631,7.631,0,0,0,1.414-4.891c0-3.806-1.957-5.871-6.85-7.068l-5.328-1.3L56.516,29.2c-3.914-2.934-7.285-4.021-12.5-4.021H30.2c-4.458,0-6.089,1.087-11.091,7.066-4.241,5.219-4.567,5.763-4.567,10.221v2.283a4.458,4.458,0,0,0,1.3,3.588l-2.61,2.39a7.289,7.289,0,0,1-2.5-5.98Zm46.642,6.633c0-4.567,3.153-7.609,7.72-7.609,4.675,0,7.72,3.044,7.72,7.609S69.669,56.16,65.1,56.16a7.365,7.365,0,0,1-6.85-3.914H33.137a7.365,7.365,0,0,1-6.85,3.914,7.335,7.335,0,0,1-7.72-7.611c0-4.567,3.153-7.609,7.72-7.609,4.675,0,7.72,3.044,7.72,7.609Zm-31.1-4.021a3.8,3.8,0,0,0-4.132,4.023,3.855,3.855,0,0,0,4.132,4.025,3.8,3.8,0,0,0,4.132-4.025C30.419,46.051,28.9,44.527,26.287,44.527Zm38.815,0A3.8,3.8,0,0,0,60.97,48.55,3.855,3.855,0,0,0,65.1,52.575a3.8,3.8,0,0,0,4.132-4.025C69.234,46.051,67.712,44.527,65.1,44.527Z" transform="translate(-10.74 -21.476)" fill="#000"/></svg>
            {{$t('form.account.test-drive')}}
          </span>
				</div>
			</div> -->
			<!-- <div class="col-12">
				<div :class="['form-control radio', {error: $v.user.payment.$dirty && $v.user.payment.$invalid}]">
					<p><strong>{{$t('form.account.payment')}} :</strong></p>
          <br v-if="$i18n.locale === 'ar'">
          <p>
            <label>
              <inline-svg :src="require('@/assets/img/icons/cash.svg')" ></inline-svg>
              {{$t('form.account.comptant')}}
              <input v-model="$v.user.payment.$model" type="radio" name="payment" value="Comptant">
              <span></span>
            </label>
          </p>
          <p>
            <label>
              <inline-svg :src="require('@/assets/img/icons/calculator-black.svg')" ></inline-svg>
              {{$t('form.account.finance')}}
              <input v-model="$v.user.payment.$model" type="radio" name="payment" value="Financement">
              <span></span>
            </label>
          </p>
          <p>
            <label>
              <inline-svg :src="require('@/assets/img/icons/trade.svg')" ></inline-svg>
              {{$t('form.account.reprise')}}
              <input v-model="$v.user.payment.$model" type="radio" name="payment" value="Reprise">
              <span></span>
            </label>
          </p>
					<div class="errors" v-if="$v.user.payment.$dirty">
						<p v-if="!$v.user.payment.required">{{$t('form.error.required.payment')}}</p>
					</div>
				</div>
      </div> -->
			<div class="col-12">
				<div class="form-control checkbox trade-in" :class="{error: $v.user.trade_in.$dirty && $v.user.trade_in.$invalid, disabled: readOnly}">
          <label>
            <inline-svg :src="require('@/assets/img/icons/trade.svg')" ></inline-svg>
            {{$t('form.account.reprise')}}
            <input v-model="$v.user.trade_in.$model" type="checkbox" name="trade_in" @change="$v.user.trade_in.$touch()" :disabled="readOnly">
            <span></span>
          </label>
				</div>
			</div>
			<div class="col-12">
				<div class="form-control checkbox" :class="{error: $v.user.terms.$dirty && $v.user.terms.$invalid}">
					<label>{{$t('notices.terms')}} <a :href="`https://www.succursalesrenault.ma/pages/informations_legales`" target="_blank">{{$t('notices.terms-link')}}</a> *
						<input v-model="$v.user.terms.$model" type="checkbox" name="terms" @change="$v.user.terms.$touch()">
						<span></span>
					</label>
				</div>
				<div class="errors" v-if="$v.user.terms.$dirty">
					<p v-if="!$v.user.terms.sameAs">{{$t('form.error.required.terms')}}</p>
				</div>
        <button type="submit" class="button button--primary"><span class="button__text">{{$t('cta.continue')}}</span></button>
				<div class="asterisks">
					<p>{{$t('notices.required')}}</p>
					<p v-html="$t('notices.law')"></p>
				</div>
			</div>
		</form>
  </div>
</template>

<script>
// import EventBus from '@/event-bus'
import { mapGetters } from 'vuex'
import InlineSvg from 'vue-inline-svg'
import { validationMixin } from 'vuelidate'
import axios from 'axios'
import { helpers, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
const custom_alpha = helpers.regex('custom_alpha', /^[a-zA-Z ]+$/)
const custom_email = helpers.regex('custom_email', /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
const custom_phone = helpers.regex('custom_phone', /^((05)|(06)|(07))[0-9]{8}$/)

export default {
  name: 'Form',
  components: {
    InlineSvg,
    Loader: () => import('@/components/Loader.vue')
  },
  mixins: [validationMixin],
  data: () => ({
    brand: process.env.VUE_APP_THEME,
    submitStatus: '',
    reSent: false,
    currentId: '',
    userAlreadyExists: false,
    thankyou: false,
    readOnly: false,
    user :{
      gender   : '',
      lastname : '',
      firstname: '',
      city     : '',
      phone    : '',
      email    : '',
      terms    : '',
      // payment  : ''
      trade_in: false
    },
  }),
  validations: {
    user : {
      gender: { required },
      lastname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      firstname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      city: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      phone: {
        required,
        custom_phone,
      },
      email: {
        required,
        custom_email,
      },
      terms: { sameAs: sameAs( () => true ) },
      // payment: { required },
      trade_in: {  },
    }
  },
  methods: {
    resendEmail() {
      this.submitStatus = 'PENDING';
      axios.post(`https://succursalesrenault.ma/onlinestore/admin/public/api/resend/${this.currentId}`)
        .then(({status}) => {
          if (status === 200 || status === 201) {
            this.reSent = true;
            this.submitStatus = 'SENT';
          }
        })
        .catch(err => console.error(err));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) this.submitStatus = 'ERROR'
      else {
        // if (this.user.payment === 'Financement' && !this.mensualite) EventBus.$emit('show-simulator-widget')
        // else {
          this.submitStatus = 'PENDING'
          const order = {
            versionId : this.version.id_simulateur,
            totalPrice: this.total,
            packIds   : this.accessories.map(acc => acc.id),
            optionIds : this.options.map(op => op.id),
            color     : this.color,
            mensualite: this.mensualite
            // mensualite: this.user.payment === 'Financement' ? this.mensualite : ''
          }
          this.user.version  = this.version.nom_version,
          this.user.model    = this.model.nom_lien.toLowerCase(),
          this.user.source   = this.utm.source
          this.user.campaign = this.utm.campaign
          axios.post('https://succursalesrenault.ma/onlinestore/admin/public/api/new-account', {...this.user, ...order})
            .then(({status, data}) => {
              if (status === 200 || status === 201) {
                if (!data) {
                  this.userAlreadyExists = true
                  this.submitStatus = 'SENT'
                  this.$emit('next-step')
                  this.$router.replace(`/${this.$i18n.locale}/commande/${this.model.nom_lien.toLowerCase()}/${this.version.nom_version}/thankyou`);
                  this.thankyou = true
                  window.scrollTo(0, 0)
                } else {
                  let storeUser = localStorage.getItem('storeUser')
                  storeUser = storeUser ? JSON.parse(storeUser) : {}
                  localStorage.setItem('storeUser', JSON.stringify({
                    id       : data,
                    gender   : this.user.gender,
                    lastname : this.user.lastname,
                    firstname: this.user.firstname,
                    city     : this.user.city,
                    phone    : this.user.phone,
                    email    : this.user.email
                  }))
                  this.currentId = data
                  const params = new URLSearchParams()
                  params.append('id_commande', data)
                  params.append('nom', this.user.lastname)
                  params.append('prenom', this.user.firstname)
                  params.append('email', this.user.email)
                  params.append('telephone', this.user.phone)
                  params.append('color', this.color.code_couleur)
                  params.append('modele', this.model.nom_lien.toLowerCase())
                  params.append('version', this.version.nom_version)
                  params.append('type_demande', 'Lead remise Onlinestore')
                  // params.append('mode_paiement', this.user.payment)
                  params.append('mode_paiement', this.mensualite ? 'Financement' : 'Comptant')
                  params.append('reprise', this.user.trade_in ? 'oui' : 'non')
                  params.append('mensualite', this.mensualite ? this.mensualite.output.mensualite_all_inclusive : '')
                  params.append('apport', this.mensualite ? this.mensualite.input.apport : '')
                  params.append('duree', this.mensualite ? this.mensualite.input.duree : '')
                  params.append('formule', this.mensualite ? this.mensualite.formule : '')
                  params.append('PassKey', process.env.VUE_APP_TELUS_KEY)
                  window.telus.post('/Save_CMD.php', params)
                    .then(({status}) => {
                      if (status === 200 || status === 201) {
                        this.submitStatus = 'SENT'
                        this.$emit('next-step')
                        window.scrollTo(0, 0)
                        gtag('event', 'conversion', {'send_to': 'AW-774209629/U0ebCOCE1OEBEN2AlvEC'})
                        if (this.user.trade_in && !this.trade) {
                          setTimeout(() => window.location.replace('https://www.succursalesrenault.ma/reprise/reprise.html?from=onlinestore'), 5000)
                        } else {
                          this.$router.replace(`/${this.$i18n.locale}/commande/${this.model.nom_lien.toLowerCase()}/${this.version.nom_version}/thankyou`);
                          this.thankyou = true
                          window.scrollTo(0, 0)
                        }
                      }
                      else this.submitStatus = 'SUBMIT_ERROR'
                    })
                    .catch(err => {
                      this.submitStatus = 'SUBMIT_ERROR'
                      console.error(err)
                    })
                }
              }
              else this.submitStatus = 'SUBMIT_ERROR'
            })
            .catch(err => {
              this.submitStatus = 'SUBMIT_ERROR'
              console.error(err)
            })
        // }
      }
    }
  },
  computed: {
		...mapGetters([
      'model',
      'version',
      'color',
      'accessories',
      'options',
      'mensualite',
      'total',
      'utm',
      'trade',
    ])
  },
	// watch: {
  //   'user.payment': function(newVal) {
  //     if (newVal === 'Financement' && !this.mensualite) EventBus.$emit('show-simulator-widget')
  //   }
	// },
  // mounted() {
  //   EventBus.$on('mensualite-changed', () => {
  //     this.user.payment = ''
  //   })
  // },
  created() {
    let storeUser = localStorage.getItem('storeUser')
    storeUser = storeUser ? JSON.parse(storeUser) : { id: '' }
    this.user = {...this.user, ...storeUser}
    this.currentId = storeUser.id
    if (this.trade) {
      this.user.trade_in = true
      this.readOnly = true
    }
  }
}
</script>

<style scoped lang="scss">
.custom-checkbox {
  position: relative;
  display: inline-block;
  margin-bottom: rem(16);
  &.animate {
    animation-name: heartBeat;
    animation-duration: 4s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 100%;
    height: 100%;
    & ~ span {
      font-family: var(--primary-font-bold);
      background-color: $white;
      font-weight: 700;
      text-transform: uppercase;
      text-align: center;
      border-radius: var(--button-border-radius);
      padding: rem(14) rem(20) rem(12);
      display: inline-block;
      @include font-size(14);
      border: rem(1) solid $black;
      svg {
        max-width: rem(30);
        vertical-align: middle;
        margin-right: rem(6);
        transform: translateY(rem(-2));
      }
      &::before {
        content: "";
        display: inline-block;
        width: rem(22);
        height: rem(22);
        border: rem(1) solid $black;
        margin-right: rem(10);
        vertical-align: text-top;
        transform: translateY(rem(2));
      }
    }
    &:checked ~ span {
      background-color: rgba(var(--primary-color), 1);
      border-color: rgba(var(--primary-color), 1);
      color: $white;
      svg path {
        fill: $white;
      }
      &::before {
        content: "\2713";
        padding-left: rem(1);
        border-color: $white;
      }
    }
  }
}
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  7% {
    transform: scale(1.2);
  }
  14% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  35% {
    transform: scale(1);
  }
}
.form {
  padding-left: rem(56);
  padding-top: rem(24);
  &--sent {
    display: table;
    margin: rem(16) auto !important;
  }
  &__title {
    position: relative;
    text-transform: uppercase;
    font-family: var(--primary-font-bold);
    @include font-size(28);
    font-weight: normal;
    margin-bottom: rem(8);
    &::before {
      content: "";
      position: absolute;
      top: rem(-3);
      left: rem(-20);
      width: rem(4);
      height: rem(40);
      background-color: rgba(var(--primary-color), 1);
    }
    small {
      display: block;
      font-family: var(--primary-font);
      text-transform: none;
      @include font-size;
    }
  }
  form {
    max-width: rem(560);
    margin: 0;
    padding-left: 0;
    [class^="col"] {
      padding: 0 rem(8);
    }
  }
  .gris {
    color: $dark-gray;
    @include font-size(14);
    margin: rem(30) 0 rem(10);
  }
  &__confirm {
    max-width: rem(500);
    margin: 0 auto;
    box-shadow: 0 0 rem(10) rgba($black, 0.3);
    text-align: center;
    .intro {
      background-color: $success-color;
      padding: rem(10) 0;
      img {
        max-width: rem(60);
      }
    }
    .content {
      padding: rem(40) rem(10);
      h2 {
        text-transform: uppercase;
        font-family: var(--primary-font-bold);
        font-weight: normal;
        @include font-size(24);
        margin-bottom: rem(30);
        small {
          text-transform: none;
          font-family: var(--primary-font);
          display: block;
          @include font-size();
          color: $dark-gray;
        }
      }
      p {
        strong {
          font-family: var(--primary-font-bold) !important;
        }
      }
      a {
        // margin-top: rem(20);
        font-family: var(--primary-font-bold);
        text-decoration: underline;
      }
    }
  }
  &__error {
    color: $error-color;
    margin-bottom: rem(16);
    @include font-size(14);
    @include breakpoint('charmeleon') {
      text-align: center;
    }
  }
  .text-green {
    text-align: center;
    font-family: var(--primary-font-bold);
    color: $success-color;
  }
  // .form-control.radio {
  //   p {
  //     margin-bottom: rem(16);
  //   }
  // }
  .form-control.trade-in {
    margin-bottom: rem(8);
    label {
      padding-top: 0;
      @include font-size(14);
    }
    &.disabled {
      label {
        cursor: not-allowed;
      }
    }
  }
  @include breakpoint('charmeleon') {
    padding-left: rem(24);
    &__title {
      @include font-size(24);
      padding-left: rem(10);
      margin-bottom: rem(30);
      &::before {
        top: 0;
        left: 0;
        height: rem(30);
      }
      small {
        @include font-size(14);
        margin-top: rem(10);
      }
    }
  }
  @include breakpoint('charmander') {
    padding: 0;
    &__title {
      margin: rem(8) rem(8) rem(16);
    }
    margin: 0 auto rem(30);
  }
  &--rtl {
    padding-left: unset;
    padding-right: rem(56);
    .form__title {
      padding-left: 0;
      padding-right: rem(10);
      &::before {
        left: initial;
        right: rem(-20);
      }
      @include breakpoint('charmeleon') {
        &::before {
          right: 0;
        }
      }
    }
    @include breakpoint('charmeleon') {
      padding-right: rem(24);
    }
    @include breakpoint('charmander') {
      padding-right: 0;
    }
  }
}
</style>